(function () {
  const root = document.querySelector('[data-jblhdr]');
  if (!root) return;

  const burger = root.querySelector('[data-jbl-burger]');
  const mnav = root.querySelector('[data-jblmnav]');
  if (!burger || !mnav) return;

  const overlay = mnav.querySelector('[data-jblmnav-overlay]');
  const closeBtn = mnav.querySelector('[data-jblmnav-close]');
  const views = Array.from(mnav.querySelectorAll('.jblmnav__view'));

function isMobile() {
  return window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
}

  function setActiveView(name) {
    views.forEach(v => v.classList.toggle('is-active', v.getAttribute('data-view') === name));
  }

  function lockScroll(lock) {
    if (lock) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
    }
  }

  // ✅ CALCOLO CORRETTO: usa il BOTTOM della barra header nel viewport
  function updateDrawerOffset() {
    const row = root.querySelector('.jblhdr__row');
    if (!row) return;

    const rect = row.getBoundingClientRect();

    // bottom = distanza dal top del viewport al fondo della barra header
    // +1px per includere il border-bottom
    const topOffset = Math.round(rect.bottom) + 1;

    // Setto con PRIORITY important così vince anche su eventuali !important nel CSS
    mnav.style.setProperty('top', `${topOffset}px`, 'important');
    mnav.style.setProperty('height', `calc(100vh - ${topOffset}px)`, 'important');
  }

  function openMobile() {
    if (!isMobile()) return;

    updateDrawerOffset();

    mnav.classList.add('is-open');
    mnav.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    setActiveView('root');
    lockScroll(true);

    // mentre è aperto, se cambia qualcosa (scroll/resize) riallineo
    window.addEventListener('resize', updateDrawerOffset, { passive: true });
    window.addEventListener('scroll', updateDrawerOffset, { passive: true });
  }

  function closeMobile() {
    mnav.classList.remove('is-open');
    mnav.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    setActiveView('root');
    lockScroll(false);

    window.removeEventListener('resize', updateDrawerOffset);
    window.removeEventListener('scroll', updateDrawerOffset);

    // reset inline style (pulito)
    mnav.style.removeProperty('top');
    mnav.style.removeProperty('height');
  }

  burger.addEventListener('click', openMobile);
  overlay && overlay.addEventListener('click', closeMobile);
  closeBtn && closeBtn.addEventListener('click', closeMobile);

  mnav.addEventListener('click', (e) => {
    const openBtn = e.target.closest && e.target.closest('[data-open-sub]');
    if (openBtn) {
      const target = openBtn.getAttribute('data-target');
      if (target) setActiveView(target);
      return;
    }

    const backBtn = e.target.closest && e.target.closest('[data-back]');
    if (backBtn) {
      setActiveView('root');
      return;
    }

    const a = e.target.closest && e.target.closest('a');
    if (a) closeMobile();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mnav.classList.contains('is-open')) closeMobile();
  });
})();
